export const parseBreadcrumbs = (breadcrumb, dictionary, locale) => {
  const dictionaryMatch = dictionary.flat[breadcrumb[0]]
  const parsedBreadcrumbs = []

  if (dictionaryMatch && dictionaryMatch.length > 0) {
    for (const bc of dictionaryMatch) {
      parsedBreadcrumbs.push({
        slug: `${bc}`,
        label: dictionary.labelsObj[bc][parseLocale(locale)],
      })
    }
  }

  return parsedBreadcrumbs.reverse()
}

const parseLocale = (locale) => {
  switch (locale) {
    case 'en-ca':
    case 'en-us':
    case 'en-eu':
      return 'en_US'
    case 'fr-ca':
      return 'fr_CA'
    case 'fr-eu':
      return 'fr_FR'
    default:
      return 'en_US'
  }
}
